import { PolygonDrawingStyle } from './PolygonDrawingStyle';

export const LengthPolygonRendering = {
	labelPrefix: 'length-frame-polygon|',
	layerId: 'hitl-length-polygons',
	/**
	 * Every frame carries the dark outline External Frames draws around its
	 * selected frames: against the plan's linework the fill alone does not give
	 * the frame a crisp edge, and the step reviews where each frame ends.
	 */
	outlineColor: PolygonDrawingStyle.selectedFrameOutlineColor,
	strokeWidth: 1.25,
	/**
	 * Selection thickens the outline rather than recolouring it, since the dark
	 * outline is now the resting state.
	 */
	selectedStrokeWidth: 2.75,
	fillAlpha: 0.25,
} as const;
